// Bitcashier brand configuration — the Svelte port of src/brands/bitcashier/config.jsx.
//
// Exactly one brand's config is bundled: vite.config.js aliases `$brand` to this file (or to
// dynamopayments/config.js) based on REACT_APP_BRAND at build time, and src/brands/index.js
// re-exports it. Importing the brand's stylesheet here keeps the brand folder self-contained,
// so the alias is the only build-time switch needed.
import "./brand.css";

// Imported (not hard-coded paths) so Vite fingerprints and emits them into static/.
import logo from "./assets/logo.png";
import logo2 from "./assets/logo2.png";
// `?inline` forces a base64 data URI regardless of the asset size limit — the PDF renderer
// embeds the image rather than fetching a URL, so it needs the bytes, not a link.
import logo2Inline from "./assets/logo2.png?inline";
import favicon from "./assets/favicon.ico";

const brand = {
  // Document title, and the name printed on PDFs / the sign-up card.
  title: "Bitcashier",
  images: {
    // Header + registration-page logo.
    logo,
    // Alternate (square/stacked) logo — used on the operation-confirmation PDFs.
    logo2,
  },
  // Fingerprinted favicon URL. (React kept a bare filename here and served it from
  // public/favicons/; the asset now lives with the brand so only the active one ships.)
  favicon,
  texts: {
    // Brand name as rendered in the app header.
    header: "Bitcashier",
  },
  // Operation-confirmation PDFs (deposit / withdrawal / trade / ledger).
  operationConfirmation: {
    // Logo URL — for on-screen previews.
    logo: logo2,
    // Same logo as a data URI — what the PDF generator actually embeds.
    logoDataUri: logo2Inline,
    styles: {
      // Heading / accent-bar colour inside the PDF.
      primary: "#e4ca3b",
      // Tinted background fill for PDF table headers and callouts.
      secondary: "#faf4d8",
    },
  },
  // Shown in the footer and in the PDF header block.
  contact: {
    websiteUrl: "www.bitcashier.io",
    email: "info@bitcashier.io",
    // Where a customer is sent when they need help with a specific operation (e.g. a payment-link
    // draft the MLRO rejected). React hard-coded this address in the view, so the DynamoPayments
    // build told their customers to email Bitcashier — it belongs per brand.
    supportEmail: "support@bitcashier.io",
  },
  // Per-brand feature flags. Plain booleans (React paired each with a component element);
  // Svelte branches on the boolean and renders the component inline.
  components: {
    // Bank (fiat) deposit instructions panel on the Deposits screen.
    bankDeposits: true,
    // "Terms have changed" acceptance modal in the app shell.
    newTermsModal: true,
  },
};

export default brand;
